import React from 'react';
import ChangePasswordRoute from './ChangePasswordRoute';

const AgentChangePasswordRoute: React.FC = () => {
  return <ChangePasswordRoute />;
};

export default AgentChangePasswordRoute;
